<template>
    <section class="sc-dashboard">
        <div class="container flex-wrapper">

            <main class="main-content layout-calc" style="position: relative;">
                <div class="row">
                    <!-- DATA PACKAGES-->
                    <div class="col-md-6 col-xl-4 col-margin-bottom-20" v-for="additionalPackage in packages.data" :key="additionalPackage.productId">
                        <Package
                            :id="additionalPackage.productId"
                            :name="additionalPackage.name"
                            :description="additionalPackage.description"
                            :locale="locale"
                            :duration="additionalPackage.duration"
                            :price="additionalPackage.price"
                            :recurring="additionalPackage.recurring"
                            :active="additionalPackage.active"
                            @openModal="openConfirmationModal(additionalPackage.bundleCode, additionalPackage.isAddon)"
                            @openDeactivateModal="openDeactivateConfirmationModal(additionalPackage.bundleCode)"
                        />
                    </div>
                    <!--BONUS PACKAGES-->
                    <div class="col-md-6 col-xl-4 col-margin-bottom-20" v-for="additionalPackage in packages.bonus" :key="additionalPackage.productId">
                        <Package
                            :id="additionalPackage.productId"
                            :name="additionalPackage.name"
                            :description="additionalPackage.description"
                            :locale="locale"
                            :duration="additionalPackage.duration"
                            :price="additionalPackage.price"
                            :recurring="additionalPackage.recurring"
                            :active="additionalPackage.active"
                            :disabled="additionalPackage.disabled || isAddonActivateDisabled(additionalPackage)"
                            :draft-line="additionalPackage.isAddon ? getDraftForPackage(additionalPackage.name, additionalPackage.productId) : null"
                            @openModal="openConfirmationModal(additionalPackage.bundleCode, additionalPackage.isAddon)"
                            @openDeactivateModal="openDeactivateConfirmationModal(additionalPackage.bundleCode)"
                            @resumeDraft="resumeDraftAddon"
                            @deleteDraft="deleteDraftAddon"
                        />
                    </div>
                    <!--ROAMING PACKAGES-->
                    <div class="col-md-6 col-xl-4 col-margin-bottom-20" v-for="additionalPackage in packages.roaming" :key="additionalPackage.productId">
                        <Package
                            :id="additionalPackage.productId"
                            :name="additionalPackage.name"
                            :description="additionalPackage.description"
                            :locale="locale"
                            :duration="additionalPackage.duration"
                            :price="additionalPackage.price"
                            :recurring="additionalPackage.recurring"
                            :active="additionalPackage.active"
                            @openModal="openConfirmationModal(additionalPackage.bundleCode, additionalPackage.isAddon)"
                            @openDeactivateModal="openDeactivateConfirmationModal(additionalPackage.bundleCode)"
                        />
                    </div>

                </div>
                <div class="row"
                     v-if="!Object.keys(packages.roaming).length && !Object.keys(packages.bonus).length && !Object.keys(packages.data).length"
                >
                    <p>
                        {{ $t('pages.additionalPackages.noPackages') }}
                    </p>
                </div>

                <div v-if="isAddonLoading" class="addon-loading-overlay">
                    <div class="addon-loading-spinner"></div>
                </div>

                <div v-if="isPackagesLoading" class="packages-loading-overlay">
                    <div class="addon-loading-spinner"></div>
                </div>

                <ConfirmationModal
                    v-if="isPackageButtonClicked"
                    @close="closeConfirmationModal"
                    @paymentAgree="sendPackageIdAndOpenModalForm"
                />

                <AddonConfirmationModal
                    v-if="showAddonConfirmationModal"
                    :reports="addonReports"
                    @close="closeAddonConfirmationModal"
                    @paymentAgree="signAddonContract"
                />

                <InsufficientFoundModal
                    :message="modalMessage"
                    @close="closeModal"
                    @redirectAccepted="redirectAccepted"
                    v-if="showInsufficientFoundModal"
                />

                <SuccessModal
                    @close="closeSuccessModal"
                    v-if="showSuccessModal"
                />
            </main>

        </div>
    </section>
</template>

<script>
import AdditionalPackages from './AdditionalPackages';
export default AdditionalPackages;
</script>

<style scoped>
.addon-loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.addon-loading-spinner {
    border: 6px solid #f3f3f3;
    border-radius: 50%;
    border-top: 6px solid #c0001a;
    width: 50px;
    height: 50px;
    animation: addon-spin 1s linear infinite;
}

.packages-loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.7);
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
}

@keyframes addon-spin {
    0%   { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>
